import { render, staticRenderFns } from "./suplicencelinfonoteTask.vue?vue&type=template&id=7c8d5f0a&scoped=true"
import script from "./suplicencelinfonoteTask.vue?vue&type=script&lang=js"
export * from "./suplicencelinfonoteTask.vue?vue&type=script&lang=js"
import style0 from "./suplicencelinfonoteTask.vue?vue&type=style&index=0&id=7c8d5f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8d5f0a",
  null
  
)

export default component.exports